/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionOrderBackwardSearchTrace } from '../../models/production-order-backward-search-trace';

export interface GetProductionOrderTraceForBackwardSearch$Params {
  productionOrderId: number;
  viewMode?: string;
}

export function getProductionOrderTraceForBackwardSearch(http: HttpClient, rootUrl: string, params: GetProductionOrderTraceForBackwardSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductionOrderBackwardSearchTrace>>> {
  const rb = new RequestBuilder(rootUrl, getProductionOrderTraceForBackwardSearch.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.query('viewMode', params.viewMode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductionOrderBackwardSearchTrace>>;
    })
  );
}

getProductionOrderTraceForBackwardSearch.PATH = '/api/v1/getProductionOrderTraceForBackwardSearch/{productionOrderId}';
